module.exports = __webpack_public_path__ + "img/class_c.2dae7aab.jpg";